export const MIME_TYPES = {
    PICTURE: ["image/jpeg", "image/png", "image/webp", "image/jpg", "image/svg+xml"],
    VIDEO: ["video/mp4"]
};
